import React, {useState} from 'react';
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';

const CheckoutForm = (props) => {
    
    const stripe = useStripe();
    const elements = useElements();

//    console.log(props);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();
        setIsLoading(true);

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        } 
        const domain_url =  window.location.protocol + '//' + window.location.host;
        const {error} = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: domain_url+'/order-received',
            },
        });


        if (error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (for example, payment
            // details incomplete)
            setErrorMessage(error.message);
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
        }
        setIsLoading(false);
    };

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            
            <PaymentElement id="payment-element" />

            <button  disabled={isLoading || !stripe || !elements} className={'btn btn-primary rounded-0 flex-fill mt-2 d-block'}>
                {isLoading ? <i className="fas fa-circle-notch fa-spin"></i> : "Pay now"}
            </button>
            {/* Show error message to your customers */}
            {errorMessage && <div className="alert alert-danger mt-3 py-1 px-3" id="payment-message">{errorMessage}</div>}
           
        </form>
    )
};

export default CheckoutForm;